import Helper from './Helper'

export default {
  install: (app) => {
    app.config.globalProperties.$helper = Helper
  }
}